/**
 * Sort items into the player's table order — the only table-order sort.
 *
 * useActiveTables decides the order; other surfaces (grid cells, carousel
 * panels) use this to line their own lists up with it instead of sorting
 * themselves. Stable, and returns the input array when already in order.
 *
 * @param order    keys in table order (index 0 = leftmost)
 * @param keyOf    reads an item's key
 * @param unranked where items missing from `order` go
 */
export const arrangeInTableOrder = <T>(
  items: T[],
  order: readonly string[],
  keyOf: (item: T) => string,
  unranked: 'first' | 'last' = 'first'
): T[] => {
  if (items.length < 2) return items;
  const missing = unranked === 'first' ? -1 : Number.MAX_SAFE_INTEGER;
  const rank = (item: T) => {
    const i = order.indexOf(keyOf(item));
    return i === -1 ? missing : i;
  };
  const sorted = [...items].sort((a, b) => rank(a) - rank(b));
  return sorted.every((item, i) => item === items[i]) ? items : sorted;
};
